// extracted by mini-css-extract-plugin
export default {"outer":"PageStatus_outer__VnHh3","animatedBackground":"PageStatus_animatedBackground__sXgrQ","inner":"PageStatus_inner__Qt3Wz"};